import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { Modal } from '@bitcine/cs-theme'
import { authCheck, logOut } from '../../api/auth'

class Idle extends Component {
  constructor(props) {
    super(props)
    this.pollInterval = null
    this.signoutTimer = null
    this.state = {
      isIdle: false,
      signoutTimerCount: 30,
      authStatus: 'AUTHED',
      currentTitle: ''
    }
    this.poll = this.poll.bind(this)
    this.stayLoggedIn = this.stayLoggedIn.bind(this)
    this.setSignoutTimer = this.setSignoutTimer.bind(this)
    this.resetSignoutTimer = this.resetSignoutTimer.bind(this)
    this.suppressEscape = this.suppressEscape.bind(this)
  }

  componentDidMount() {
    this.pollInterval = setInterval(this.poll, 10000)
    document.addEventListener('keydown', this.suppressEscape, true)
  }

  componentWillUnmount() {
    clearInterval(this.pollInterval)
    clearTimeout(this.signoutTimer)
    document.removeEventListener('keydown', this.suppressEscape, true)
  }

  suppressEscape(e) {
    if (this.state.isIdle && e.keyCode === 27) e.stopPropagation()
  }

  poll() {
    if (this.state.isIdle) return
    const { session_lifetime_minutes = 60 } = this.props
    const warningThreshold = Math.max(0, (session_lifetime_minutes - 2) * 60 * 1000)
    if (warningThreshold === 0) return
    const lastActivity = this.props.last_api_activity ?? Date.now()
    const elapsed = Date.now() - lastActivity
    if (elapsed >= warningThreshold) {
      this.setState({
        isIdle: true,
        authStatus: 'AUTHED',
        currentTitle: document.title
      })
      this.setSignoutTimer()
    }
  }

  stayLoggedIn() {
    this.setState({ authStatus: 'CHECKING' })
    this.props.authCheck()
      .then(() => {
        this.resetSignoutTimer()
        document.title = this.state.currentTitle
        this.setState({ isIdle: false, authStatus: 'AUTHED' })
      })
      .catch(() => {
        this.resetSignoutTimer()
        document.title = this.state.currentTitle
      })
  }

  setSignoutTimer() {
    this.signoutTimer = setTimeout(() => {
      if (this.state.signoutTimerCount <= 1) {
        document.title = this.state.currentTitle
        this.props.logOut()
      } else {
        this.setState(
          prevState => ({ signoutTimerCount: prevState.signoutTimerCount - 1 }),
          () => {
            document.title = `🔴 Signing out in ${this.state.signoutTimerCount} seconds — ${this.state.currentTitle}`
            this.setSignoutTimer()
          }
        )
      }
    }, 1000)
  }

  resetSignoutTimer() {
    clearTimeout(this.signoutTimer)
    this.setState({ signoutTimerCount: 30 })
  }

  render() {
    const { isIdle, signoutTimerCount, authStatus } = this.state

    return (
      <div>
        <Modal open={isIdle} onClose={() => {}} clickOutsideCloses={false} title='Inactive' isDismissable={false}>
          {authStatus === 'CHECKING' ? (
            <div className='py4 center'>
              <div className='spinner'/>
            </div>
          ) : (
            <div className='py4 center'>
              <i className='material-icons'>warning</i>
              <div>
                <h3>Inactive</h3>
                <p>
                  You will be signed out in <strong>{signoutTimerCount}</strong> seconds.
                </p>
                <button className='cs-button' onClick={this.stayLoggedIn}>Stay logged in</button>
              </div>
            </div>
          )}
        </Modal>

        <div>{this.props.children}</div>
      </div>
    )
  }
}

Idle.propTypes = {
  children: PropTypes.node.isRequired,
  session_lifetime_minutes: PropTypes.number,
  last_api_activity: PropTypes.number,
  authCheck: PropTypes.func.isRequired,
  logOut: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  session_lifetime_minutes: state.auth.session_lifetime_minutes,
  last_api_activity: state.utilities.last_api_activity
})

const mapDispatchToProps = dispatch => ({
  authCheck: bindActionCreators(authCheck, dispatch),
  logOut: bindActionCreators(logOut, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(Idle)
